import { render, staticRenderFns } from "./changepasswordinitial.vue?vue&type=template&id=b82ccf80&scoped=true&"
import script from "./changepasswordinitial.vue?vue&type=script&lang=js&"
export * from "./changepasswordinitial.vue?vue&type=script&lang=js&"
import style0 from "./changepasswordinitial.vue?vue&type=style&index=0&id=b82ccf80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82ccf80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAvatar,VContainer,VForm,VRow,VTextField})
